import { createSelector } from 'reselect';
import { RootState } from 'src/redux/store';

const selectTaxCertificate = (state: RootState) => state.taxCertificate;

const selectTaxCertificateLoading = createSelector(
  selectTaxCertificate,
  (state) => state?.isLoading
);

const selectTaxCertificateList = createSelector(
  selectTaxCertificate,
  (state) => state?.taxCertificateList
);

const selectTaxCertificateMeta = createSelector(
  selectTaxCertificate,
  (state) => state?.taxCertificateListMeta
);

const selectTaxCertificateParams = createSelector(
  selectTaxCertificate,
  (state) => state?.taxCertificateListFilterParams
);

const selectTaxCertificateLinks = createSelector(
  selectTaxCertificate,
  (state) => state?.taxCertificateListLinks
);

const selectTaxCertificateColumns = createSelector(
  selectTaxCertificate,
  (state) => state?.taxCertificateColumn
);

const selectIsLoading = createSelector(
  selectTaxCertificate,
  (state) => state?.isLoading
);

const selectTaxCertificateDetails = createSelector(
  selectTaxCertificate, (state) => state?.taxCertificateDetails
)

export const selectors = {
  selectIsLoading,
  selectTaxCertificate,
  selectTaxCertificateList,
  selectTaxCertificateMeta,
  selectTaxCertificateLinks,
  selectTaxCertificateParams,
  selectTaxCertificateLoading,
  selectTaxCertificateColumns,
  selectTaxCertificateDetails,
};
